import React, { Component } from "react";
import { Table, Modal, Image } from "react-bootstrap";

import { appConfig } from "../../config";
import CreditNotePDFView from "./creditNotePDFView";
import ModalImage from "react-modal-image";

var dateFormat = require("dateformat");
class CreditNotesView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  mouseOver = (data) => {
    this.setState({ creditNotePdfModal: true, creditNoteData: data });
  };

  closePdfModel = () => {
    this.setState({ creditNotePdfModal: false });
  };

  getExtension = (filename) => {
    return filename.split(".").pop();
  };

  render() {
    const data =
      this.props.CreditNotesDtls && this.props.CreditNotesDtls.item
        ? this.props.CreditNotesDtls && this.props.CreditNotesDtls.item
        : null;

    console.log(data);

    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Credit Notes Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="Commondetlsmodelview">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td className="feedbkTdWdth"> Credit Number </td>
                        <td className="feedbkModalCap">
                          {data !== null && data.crdtRefNo}
                        </td>
                      </tr>
                      <tr>
                        <td> Credit From </td>
                        <td className="feedbkModalCap">
                          {/* {data !== null &&
                            data.crdtFrom !== null &&
                            data.crdtFrom.name} */}
                          {data !== null &&
                            data.dstbtrDtls !== null &&
                            data.dstbtrDtls.name}
                        </td>
                      </tr>
                      <tr>
                        <td> Credit To </td>
                        <td className="feedbkModalCap">
                          {/* {data !== null &&
                            data.crdtTo !== null &&
                            data.crdtTo.name} */}
                          {data !== null &&
                            data.chmstDtls !== null &&
                            data.chmstDtls.name}
                        </td>
                      </tr>
                      {/* <tr>
                        <td> Distributor GST </td>
                        <td className="feedbkModalCap">
                          {data !== null && data.crdtFromGST}
                        </td>
                      </tr> */}
                      <tr>
                        <td> Chemist GST </td>
                        <td className="feedbkModalCap">
                          {data !== null && data.crdtToGST}
                        </td>
                      </tr>
                      {/* <tr>
                        <td>Quantity </td>
                        <td className="feedbkModalCap">
                          {data !== null && data.qnty}
                        </td>
                      </tr> */}

                      <tr>
                        <td> Amount </td>
                        <td className="feedbkModalCap">
                          {data !== null && data.amnt}
                        </td>
                      </tr>

                      <tr>
                        <td>Credit Note Preview</td>
                        <td className="storeModalCap">
                          <div>
                            {data && data.imgUrl ? (
                              this.getExtension(data.imgUrl) === "pdf" ? (
                                <div>
                                  <Image
                                    className="ctgryImg"
                                    style={{ cursor: "pointer" }}
                                    src={[
                                      data && data.imgUrl !== undefined
                                        ? appConfig.imgServerip +`/getCrdtImg?imgName=${data.imgUrl}`
                                        : require("../../assets/img/default_pdf_icon.png"),
                                    ]}
                                    onClick={() =>
                                      data.imgUrl !== undefined
                                        ? this.mouseOver({ data: data.imgUrl })
                                        : null
                                    }
                                  />
                                  <CreditNotePDFView
                                    show={this.state.creditNotePdfModal}
                                    handleClose={this.closePdfModel}
                                    creditNoteData={this.state.creditNoteData}
                                  />
                                </div>
                              ) : (
                                <ModalImage
                                  small={
                                    data &&
                                    data.imgUrl &&
                                    appConfig.imgServerip +
                                      `/getCrdtImg?imgName=${data.imgUrl}`
                                  }
                                  large={
                                    data &&
                                    data.imgUrl &&
                                    appConfig.imgServerip +
                                      `/getCrdtImg?imgName=${data.imgUrl}`
                                  }
                                  hideDownload={true}
                                  hideZoom={true}
                                  className="ctgryImg"
                                />
                              )
                            ) : null}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td> Description </td>
                        <td className="feedbkModalCap">
                          <span
                            style={{
                              whiteSpace: "pre-wrap",
                              overflowWrap: "break-word",
                            }}
                          >
                            {data !== null && data.descp}
                          </span>
                        </td>
                      </tr>

                      <tr>
                        <td> Created Date & Time</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            data.createdAt !== null &&
                            dateFormat(
                              data.createdAt,
                              "mmmm dS, yyyy, h:MM TT"
                            )}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default CreditNotesView;
